/**
 * Qué puede hacer el usuario con un reporte del Creador (biblioteca y editor).
 * Copia de backend/report_capabilities.js: el servidor manda `capabilities` ya calculadas
 * y valida de nuevo; esto es el respaldo del navegador para ocultar lo que no aplica.
 */

/**
 * @param {object} perms   Permisos del rol (userPermissions).
 * @param {object} report  { accessType: 'edit'|'view'|null, createdBy, isDraft }.
 * @param {string} uid     Usuario actual.
 * @returns {object} Banderas canView, canOpen, canEdit, canDuplicate, canDelete, canShareUsers,
 *   canShareGroups, canChangeUserAccess, canRevokeUser, canSeeAccess.
 */
export function reportCapabilities(perms = {}, report = {}, uid = '') {
    const p = perms || {};
    const isAuthor = Boolean(uid && report.createdBy && report.createdBy === uid);
    const access = report.accessType || null;
    const canView = Boolean(p.reports_view_all || access || isAuthor);
    const creator = Boolean(p.reports_custom_creator);
    const canEdit = Boolean(
        p.reports_edit
        || (creator && (p.reports_view_all || access === 'edit' || isAuthor))
    );
    const canShareUsers = Boolean(p.permissions_assign_direct);
    const canShareGroups = Boolean(p.groups_manage_permissions);
    return {
        canView,
        canOpen: canView && !report.isDraft,
        canEdit: canView && canEdit,
        canDuplicate: canView && Boolean(p.reports_create || creator),
        canDelete: canView && Boolean(p.reports_delete),
        canShareUsers: canView && canShareUsers,
        canShareGroups: canView && canShareGroups,
        canChangeUserAccess: canView && Boolean(p.permissions_update_access_type),
        canRevokeUser: canView && Boolean(p.permissions_delete),
        canSeeAccess: canView && Boolean(p.reports_view_access_users || canShareUsers || canShareGroups),
    };
}

/** Las capabilities que mandó el servidor, o las calculadas aquí si no vinieron. */
export function capabilitiesFor(report, perms, uid) {
    return report?.capabilities || reportCapabilities(perms, report || {}, uid);
}
